import gsap from "gsap";
import EventDispatcher from "../common/EventDispatcher";
import { Global } from "../common/global";

export default class Assignment {
  constructor() {
    document
      .querySelector("#taskInfo #nextBtn")
      .addEventListener("click", this.onNext.bind(this));

    this.nextBtnFlag = false;

    this.scenarioInfo = {
      conflict: {
        title: "संघर्ष वाली जगह से रिपोर्ट करना",
        desc: "आपको संघर्ष वाली जगह पर डिप्लॉय किया गया है, जहां सटीकता और सुरक्षा बहुत ज़रूरी है. ऐसा प्रोटेक्टिव और रिपोर्टिंग गियर चुनें जो आपको स्टोरी कवर करने में मदद करें और आपको सुरक्षित रखें.<br/><br/>रिपोर्टिंग में इस्तेमाल होने वाली 10 चीज़ें खोजें.",
        items: [
          "flak_jacket",
          "firstaid",
          "foodpack",
          "torch",
          "walkie",
          "gas_mask",
          "mic",
          "tripod",
          "tent",
          "sleepy_bag",
        ],
      },
      cyclone: {
        title: "तूफ़ान के समय रिपोर्टिंग",
        desc: "एक बड़ा तूफ़ान आने वाला है. इस तूफ़ान के बीच से आपको रिपोर्टिंग करनी है. सावधान रहें, अलर्ट रहें और रिपोर्टिंग के लिए ज़रूरी सामान जुटाएं.<br/><br/>रिपोर्टिंग में इस्तेमाल होने वाली 10 चीज़ें खोजें.",
        items: [
          "life_jacket",
          "gum_boot",
          "umbrerlla",
          "raincoat",
          "foodpack",
          "walkie",
          "battery",
          "tent",
          "sleepy_bag",
          "generator",
        ],
      },
      remote: {
        title: "रिमोट एरिया से कवरेज",
        desc: "आप ऐसी जगह कवरेज के लिए जा रहे हैं, जहां न नेटवर्क है, न बुनियादी सुविधाएं. सिर्फ़ वो सामान चुनें, जो ज़रूरी हैं.<br/><br/>रिपोर्टिंग में इस्तेमाल होने वाली 10 चीज़ें खोजें.",
        items: [
          "tent",
          "sleepy_bag",
          "cookset",
          "stove",
          "firstaid",
          "mosquito",
          "mic",
          "walkie",
          "tripod",
          "foodpack",
        ],
      },
    };
  }
  init() {
    this.screenActive = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
    }
  }
  showScreen(data) {
    if (data["screenKey"] !== "Assignment") return false;

    //Global.scenario

    this.screenActive = true;

    document.querySelector("#taskInfo .sub_title").innerHTML =
      this.scenarioInfo[Global.scenario].title;
    document.querySelector("#taskInfo .desc").innerHTML =
      this.scenarioInfo[Global.scenario].desc;

    this.scenarioInfo[Global.scenario].items.forEach((item, index) => {
      document.querySelector(
        `#taskInfo .icons .icon:nth-child(${index + 1}) img`,
      ).src = `./ui/icons/${item}.png`;
    });

    setTimeout(() => {
      document.querySelector("#taskInfo").classList.add("active");
      this.nextBtnFlag = true;
    }, 0);
    setTimeout(() => {
      document.querySelector("#taskInfo").classList.add("active2");
    }, 10);
  }
  animateScreen() {}

  hideScreen() {
    if (!this.screenActive) return;
    this.screenActive = false;
    document.querySelector("#taskInfo").classList.add("active3");
    setTimeout(() => {
      document.querySelector("#taskInfo").classList.remove("active3");
      document.querySelector("#taskInfo").classList.remove("active2");
      document.querySelector("#taskInfo").classList.remove("active");
    }, 800);
    // document.querySelector('#homeScr').classList.remove('active2');
    // document.querySelector('#homeScr').classList.remove('active2');
  }
  onNext() {
    if (!this.nextBtnFlag) return;
    this.nextBtnFlag = true;
    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: "360nextClick",
      uniqID: Global.U_ID,
    });
    this.hideScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "Instruction",
        },
      },
    });
  }
}
